// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

// Component Files
import { EditControlsComponent } from './edit-controls.component';

// Directives
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
    declarations: [
        EditControlsComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        MatIconModule,
        MatButtonModule,
        DirectivesModule
    ],
    exports: [
        EditControlsComponent
    ]
})
export class EditControlsModule { }